export const iconFontAwesomeLogisticsPlaneCircleCheck = (
	<i className="fa-solid fa-plane-circle-check"></i>
);
